import BaseApi from '@/api/Base/BaseApi'
import { AnomalyClusteringResponse } from '@/api/AnomalyClustering/types'

const ROOT = '/anomaly-clustering'

export default class AnomalyClusteringApi extends BaseApi {
  getAnomalyClustering(itemId: string) {
    return this.agent.get<AnomalyClusteringResponse>(`${ROOT}/${itemId}`)
  }
}
